import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SkeletonContextProvider } from '../../context';
import { useIsLoadingValue } from '../../hooks';
export function WithSkeleton({ children, skeleton, loading }) {
    const isLoading = useIsLoadingValue(loading);
    if (isLoading) {
        return _jsx(SkeletonContextProvider, { loading: true, children: skeleton });
    }
    return _jsx(_Fragment, { children: children });
}
